import { render } from "./QuestionnaireFinalComponent.vue?vue&type=template&id=703b36bd&scoped=true&ts=true"
import script from "./QuestionnaireFinalComponent.vue?vue&type=script&lang=ts"
export * from "./QuestionnaireFinalComponent.vue?vue&type=script&lang=ts"

import "./QuestionnaireFinalComponent.vue?vue&type=style&index=0&id=703b36bd&scoped=true&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-703b36bd"]])

export default __exports__